import { formatDistanceToNow } from "date-fns";
import { de, enUS, fr } from "date-fns/locale";

type SupportedLanguage = "de" | "en" | "fr";

function getSupportedLanguage(language?: string): SupportedLanguage {
  const baseLanguage = language?.split("-")[0];
  if (baseLanguage === "de" || baseLanguage === "fr") {
    return baseLanguage;
  }
  return "en";
}

export function formatAbsoluteDateTime(
  dateString?: string | null,
  language?: string,
): string | undefined {
  if (!dateString) {
    return undefined;
  }

  return new Intl.DateTimeFormat(getSupportedLanguage(language), {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(dateString));
}

export function formatRelativeTime(
  dateString: string,
  language?: string,
): string {
  const supportedLanguage = getSupportedLanguage(language);
  const locale =
    supportedLanguage === "de" ? de : supportedLanguage === "fr" ? fr : enUS;

  return formatDistanceToNow(new Date(dateString), {
    addSuffix: true,
    locale,
    includeSeconds: true,
  });
}
